// extracted by mini-css-extract-plugin
export default {"m":"ServiceStuff_m__tTNNt","gt":"ServiceStuff_gt__sOVLc","gn":"ServiceStuff_gn__WqKpX"};